export default __webpack_public_path__ + "static/media/service_8.b1c09cee.jpg";